import { http } from "../client";
export var deleteTimetable = function (id) {
    return http.api.delete("timetables/".concat(id)).then(function (response) { return response.data; });
};
